import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  selectedCustomersSelector,
  selectedDivisionsSelector,
  selectedZonesSelector,
} from "../features/authentication/auth-slice";
import { getParsedLocalStorage } from "../Utils/storage-utils";
import { extractUserDataFromPermission } from "../Utils/Utils";
type SingleDropdownType = { id: string; value: string };

export const useGetPermissions = () => {
  const permissions = localStorage.getItem("permissions");
  return useMemo(() => permissions, []);
}
export function usePermissions() {
  let permissions = getParsedLocalStorage("permissions", []);
  const {
    outermostKeys: zone,
    outerToInnerKeys: zone_to_division_map,
    innerToCustomerNames: division_to_station_map,
    innerToCustomers,
    ...rest
  }: any = extractUserDataFromPermission(permissions);
  const selected_zones = useSelector(selectedZonesSelector);
  const selected_divisions = useSelector(selectedDivisionsSelector);
  const selected_customers = useSelector(selectedCustomersSelector);
  const selected_zone_set = new Set(selected_zones.map((zone: SingleDropdownType) => zone.value));
  const selected_divisions_set = new Set(selected_divisions.map((division: SingleDropdownType) => division.value));
  const selected_stations_set = new Set(selected_customers.map((station: any) => station.customerName));
  const zone_list = selected_zones.map((zone: SingleDropdownType) => zone.value);
  for (const _zone in zone_to_division_map) {
    if (!selected_zone_set.has(_zone)) {
      delete zone_to_division_map[_zone as keyof typeof zone_to_division_map];
      continue;
    }
    const divisions: string[] = zone_to_division_map[_zone as keyof typeof zone_to_division_map];
    const division_list = [];
    for (const division of divisions) {
      if (selected_divisions_set.has(division)) {
        division_list.push(division);
      }
    }
    zone_to_division_map[_zone as keyof typeof zone_to_division_map] = division_list;
  }
  for (const _division in division_to_station_map) {
    if (!selected_divisions_set.has(_division)) {
      delete division_to_station_map[_division as keyof typeof division_to_station_map];
      continue;
    }
    const stations: string[] = division_to_station_map[_division as keyof typeof division_to_station_map];
    const station_with_id = innerToCustomers[_division];

    const stations_list = [];
    const station_list_with_id = [];
    for (const station of stations) {
      if (selected_stations_set.has(station)) {
        stations_list.push(station);
        const selected_station_with_id = station_with_id.find((stn: any) => stn.customerName === station);
        station_list_with_id.push(selected_station_with_id);
      }
    }
    innerToCustomers[_division] = station_list_with_id;
    division_to_station_map[_division as keyof typeof division_to_station_map] = stations_list;
  }

  return useMemo(
    () => ({
      outermostKeys: zone_list,
      outerToInnerKeys: zone_to_division_map,
      innerToCustomerNames: division_to_station_map,
      innerToCustomers,
      ...rest,
    }),
    [selected_zones, selected_divisions, selected_customers],
  );
}